import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ScrollComponent } from '../../common/scrollComponent'
import { SaveRoute } from '../../layout/SaveRoute'
import { Footer } from '../../layout/footer'
import { SENTIMENT_TYPE } from '../common/constant'
import { Header } from './Header'
import {
  ALERT_LIST_CONTAINER_SCROLL_ID,
  READ_STATUS,
  TIME_PERIOD,
} from './constant'
import { Highlight } from './highlight'
import './i18n'
import classes from './index.module.scss'
import { SearchBox } from './searchBox'
import { SideBar } from './sideBar'
import { changeFilter, resetData, selectFilter } from './store/slice'
import {
  getAlertCriteriaDynamic,
  getAlertHighlight,
  getAlertList,
} from './store/thunk'
import { AlertTable } from './table'

const AlertList = () => {
  return (
    <SaveRoute>
      <div className={classes.root}>
        <Header />
        <div className={classes.content}>
          <SideBar />
          <div className={classes.mainContent}>
            <ScrollComponent id={ALERT_LIST_CONTAINER_SCROLL_ID}>
              <div className="h100 flexColumn">
                <div className="dFlex justifyContentBetween alignItemsStart px3 gap2 flexWrap">
                  <SearchBox />
                  <Highlight />
                </div>
                <div className="flex1 minH0 px3">
                  <AlertTable />
                </div>
              </div>
              <Footer />
            </ScrollComponent>
          </div>
        </div>
      </div>
      <ListenCallApi />
    </SaveRoute>
  )
}

const ListenCallApi = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const filterStr = useSelector(selectFilter(null, JSON.stringify))
  const filter = JSON.parse(filterStr)

  useEffect(() => {
    const payload = {}
    const isDefaultUnread = searchParams.get('readStatus') === 'unread'
    const isDefaultNegative = searchParams.get('sentiment') === 'negative'
    if (isDefaultUnread) payload.readStatus = [READ_STATUS.UNREAD.value]
    if (isDefaultNegative) payload.sentiment = [SENTIMENT_TYPE.NEGATIVE.id]
    if (isDefaultUnread || isDefaultNegative) {
      setSearchParams({}, { replace: true })
    }
    dispatch(changeFilter(payload))
  }, [])

  useEffect(() => {
    dispatch(getAlertCriteriaDynamic())
  }, [])

  useEffect(() => {
    const {
      organizationId,
      industryId,
      readStatus,
      subjectType,
      sentiment,
      startDate,
      endDate,
      criteria,
      page,
      pageSize,
      timePeriod,
    } = filter

    const params = {
      organizationId,
      vsicId: industryId,
      readStatus: readStatus.length === 1 ? readStatus[0] : undefined,
      subjectType: subjectType.length ? subjectType : undefined,
      sentimentId: sentiment.length ? sentiment : undefined,
      alertCriteriaId: criteria.length ? criteria : undefined,
      fromDate: startDate,
      toDate: timePeriod === TIME_PERIOD.CUSTOM.key ? endDate : undefined,
      page,
      pageSize,
    }

    dispatch(getAlertHighlight({ ...params, toDate: endDate }))
    dispatch(getAlertList(params))
  }, [locale, filter])

  useEffect(() => {
    return () => dispatch(resetData())
  }, [])

  return null
}

export default AlertList
